import { ELOOP } from 'constants';
import vue from '../../main';


const CryptoJS = require('crypto-js');  //引用AES源码js

const key = CryptoJS.enc.Utf8.parse("cisdom2019oaswpk");  //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('cisdom2019oaswiv');   //十六位十六进制数作为密钥偏移量

export function Encrypt(content) {//加密
  var encrypted = CryptoJS.AES.encrypt(content, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return encrypted.toString()
}
export function Decrypt(content) {//解密
  var bytes = CryptoJS.AES.decrypt(content.toString(), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  var decryptResult = CryptoJS.enc.Utf8.stringify(bytes).toString();
  return decryptResult
}
export function getLocal(key){
  return localStorage.getItem(key)
}
export function setLocal(key,val){
  localStorage.setItem(key,val);
}
export function removeLocal(key){
  localStorage.removeItem(key)
}





//签名
function getSign(){
  return Encrypt('cisdom2019@'+Date.parse(new Date())+'@'+getRandSix())
}
//6位随机数
function getRandSix(){
  var num='';
  for(var i=0;i<6;i++){
      num+=Math.floor(Math.random()*10);
  }
  return num;
}
//计算时间差
function timeDifference(start,end,diffType) {
  var startTime = new Date(start.replace(/\-/g, "/")),
      endTime=new Date(end.replace(/\-/g, "/"));
  //作为除数的数字
  var timeType =1;
  switch (diffType) {
      case"second":
          timeType =1000;
          break;
      case"minute":
          timeType =1000*60;
          break;
      case"hour":
          timeType =1000*3600;
          break;
      case"day":
          timeType =1000*3600*24;
          break;
      default:
          break;
  }
  return parseInt((endTime.getTime() - startTime.getTime()) / parseInt(timeType));
}
//判断手机号
function isPoneAvailable(rule, value, callback) {
  var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!value) {
    return callback(new Error("请输入手机号"));
  } else {
    if (myreg.test(value)) {
      callback();
    } else {
      return callback(new Error('手机号格式不正确'))
    }
  }
}
// 验证是否整数
function isInteger(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可为空'));
  }
  setTimeout(() => {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 0);
}
//判断可为空的整数
function isEmptyInteger(rule, value, callback){
  if (!value) {
    callback();
  }else{
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }
}
//判断邮箱
export function validateEMail(rule, value,callback) {
  const reg =/^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
  if(value==''||value==undefined||value==null){
    callback();
  }else{
    if (!reg.test(value)){
      callback(new Error('请输入正确的邮箱地址'));
    } else {
      callback();
    }
  }
}
//判断整数或小数
export function validateFloatInt(rule, value,callback) {
  const regInt =/^[0-9]*[1-9][0-9]*$/;
  const regFloat =/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if(value==''||value==undefined||value==null){
      callback();
  }else{
      if (regInt.test(value)||regFloat.test(value)){
        callback();
      } else {
        callback(new Error('请输入整数或最多两位小数'));
      }
  }
}
/* 是否身份证号码*/
export function validateIdNo(rule, value,callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if(!value){
    callback();
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的身份证号码'));
    } else {
      callback();
    }
  }
}

//七牛地址
let qiniuUrl='//upload-z1.qiniup.com'//华北
//let qiniuAddr='http://noaqn.cisdom.com.cn/'
let qiniuAddr='//rsqn.cisdom.com.cn/'

//公告类型
let noticeType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'公告'
  },
  {
    id:'2',
    name:'审批信息'
  },
  {
    id:'3',
    name:'日志信息'
  },
  {
    id:'4',
    name:'人事变动'
  },
  {
    id:'5',
    name:'任务信息'
  },
  {
    id:'6',
    name:'薪资信息'
  },
  {
    id:'7',
    name:'绩效信息'
  },
]
//轮播图类型
let sliderType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'静态图'
  },
  {
    id:'2',
    name:'网页'
  }
]
//轮播图位置
let sliderLocation=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'工作台'
  },
  {
    id:'2',
    name:'手机端'
  }
]
//工作年限
let workYear=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'0',
    name:'不限'
  },
  {
    id:'1',
    name:'1-3年'
  },
  {
    id:'2',
    name:'3-5年'
  },
  {
    id:'3',
    name:'5-7年'
  },
  {
    id:'4',
    name:'7-10年'
  },
  {
    id:'5',
    name:'10年以上'
  }
]
//学历要求
let educationList=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'0',
    name:'不限'
  },
  {
    id:'2',
    name:'初中以上'
  },
  {
    id:'3',
    name:'高中以上'
  },
  {
    id:'4',
    name:'大专以上'
  },
  {
    id:'5',
    name:'本科以上'
  },
  {
    id:'6',
    name:'硕士以上'
  },
  {
    id:'7',
    name:'博士'
  }
]
//拥有学历
let educationOwn=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'小学'
  },
  {
    id:'2',
    name:'初中'
  },
  {
    id:'3',
    name:'高中'
  },
  {
    id:'8',
    name:'职高'
  },
  {
    id:'9',
    name:'中专'
  },
  {
    id:'4',
    name:'大专'
  },
  {
    id:'5',
    name:'本科'
  },
  {
    id:'6',
    name:'硕士'
  },
  {
    id:'7',
    name:'博士'
  },
  {
    id:'0',
    name:'其他'
  }
]
//性别
let sexList=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'男'
  },
  {
    id:'2',
    name:'女'
  },
]
//招聘渠道
let channelList=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'智联招聘'
  },
  {
    id:'2',
    name:'拉钩网'
  },
  {
    id:'3',
    name:'猎聘网'
  },
  {
    id:'4',
    name:'前程无忧'
  },
  {
    id:'5',
    name:'58同城'
  },
  {
    id:'6',
    name:'赶集网'
  },
  {
    id:'7',
    name:'Boos直聘'
  },
  {
    id:'8',
    name:'中华英才网'
  },
  {
    id:'0',
    name:'其他'
  }
]
//用户状态
let userState=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'已激活'
  },
  {
    id:'2',
    name:'已离职'
  },
  {
    id:'3',
    name:'待激活'
  },
]
//证件类型
let voucherTypeList=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'身份证'
  },
  {
    id:'2',
    name:'外国护照'
  },
  {
    id:'3',
    name:'港澳居民来往内地通行证'
  },
  {
    id:'4',
    name:'台湾居民来往内地通行证'
  },
  {
    id:'0',
    name:'其他'
  }
]
//职位状态
let workState=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'试用'
  },
  {
    id:'2',
    name:'正式'
  },
]
/*员工状态
注：待转正查询  state:4  查询结果为4，7的数据
未转正查询  state:6  查询结果为6，8
*/
let userStatus=[
  {
    id:'1',
    name:'待入职'
  },
  {
    id:'2',
    name:'已入职'
  },
  {
    id:'3',
    name:'未入职'
  },
  {
    id:'4',
    name:'待转正'
  },
  {
    id:'5',
    name:'已转正'
  },
  {
    id:'6',
    name:'未转正'
  },
  {
    id:'7',
    name:'待审批'
  },
  {
    id:'8',
    name:'审批拒绝'
  },
]
//调动类型
let removeType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'调岗'
  },
  {
    id:'2',
    name:'晋升'
  },
  {
    id:'3',
    name:'降级'
  },
]
//调动状态
let removeStatus=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'待调动'
  },
  {
    id:'2',
    name:'已调动'
  },
  {
    id:'3',
    name:'放弃调动'
  },
  {
    id:'4',
    name:'待调动审核'
  },
]
//离职状态
let leaveStatus=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'待离职'
  },
  {
    id:'2',
    name:'已离职'
  },
  {
    id:'3',
    name:'放弃离职'
  },
  {
    id:'4',
    name:'待离职审核'
  },
]
//考勤组类型
let checkingInType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'固定班制'
  },
  {
    id:'2',
    name:'排班制'
  },
  {
    id:'3',
    name:'自由调休制'
  },
]
let checkingInType2=[
  {
    id:'1',
    name:'固定班制'
  },
  {
    id:'2',
    name:'排班制'
  },
  {
    id:'3',
    name:'自由调休制'
  },
]
//假期单位
let holidayUnit = [
  {
    id:'1',
    name:'小时'
  },
  {
    id:'2',
    name:'天'
  },
]
//最小假期单位设置
let holidayMin = [
  {
    id:'1',
    name:'0.5'
  },
  {
    id:'2',
    name:'1'
  },
  {
    id:'3',
    name:'2'
  },
  {
    id:'4',
    name:'3'
  },
  {
    id:'5',
    name:'4'
  },
  {
    id:'6',
    name:'5'
  },
  {
    id:'7',
    name:'6'
  },
  {
    id:'8',
    name:'7'
  },
  {
    id:'9',
    name:'8'
  },
  {
    id:'10',
    name:'9'
  },
  {
    id:'11',
    name:'10'
  },
];
//班次打卡规则
let classestype = [
  {
    id:'1',
    name:'早晚打卡'
  },
  {
    id:'2',
    name:'分段打卡'
  },
]
//打卡方式
let clockInType = [
  {
    id:'1',
    name:'满足地址范围打卡'
  },
  {
    id:'2',
    name:'满足Wifi范围打卡'
  },
  {
    id:'3',
    name:'满足其中一个打卡'
  },
  {
    id:'4',
    name:'同时满足打卡'
  },
]
//任务状态
let taskStatus=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'待处理'
  },
  {
    id:'2',
    name:'进行中'
  },
  {
    id:'3',
    name:'已完成'
  },
  {
    id:'4',
    name:'关闭'
  }
]
//外勤类型
let outType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'外出'
  },
  {
    id:'2',
    name:'出差'
  },
]
//加班类型
let overtimeType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'工作日加班'
  },
  {
    id:'2',
    name:'休息日加班'
  },
  {
    id:'3',
    name:'节假日加班'
  },
]
//重复类型
let repeatType=[
  {
    id:'1',
    name:'不重复'
  },
  {
    id:'2',
    name:'每天重复'
  },
  {
    id:'3',
    name:'每月重复'
  },
]
//任务状态
let taskType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'1',
    name:'待处理'
  },
  {
    id:'2',
    name:'进行中'
  },
  {
    id:'3',
    name:'已完成'
  },
  {
    id:'4',
    name:'已关闭'
  },
]
//考核状态
let perfType=[
  {
    id:'',
    name:'全部'
  },
  {
    id:'0',
    name:'未开始'
  },
  {
    id:'1',
    name:'考核中'
  },
  {
    id:'2',
    name:'待归档'
  },
  {
    id:'3',
    name:'已归档'
  },

]
//考核周期
let cycle = [
  {
    id:'1',
    name:'周'
  },
  {
    id:'2',
    name:'月'
  },
  {
    id:'3',
    name:'季'
  },
  {
    id:'4',
    name:'年'
  },
]
//考核状态
let assessState = [
  {
    id:'',
    name:'全部'
  },
  {
    id:'0',
    name:'未开始'
  },
  {
    id:'1',
    name:'考核中'
  },
  {
    id:'2',
    name:'待归档'
  },
  {
    id:'3',
    name:'已结束'
  },
]
//定薪类型
let PayType = [
  {
    id:'1',
    name:'实习期'
  },
  {
    id:'2',
    name:'正式员工'
  },
]
//中文数字
let ChineseNum=['一','二','三','四','五','六','七','八','九','十']
//基础库
let baseModule = [
  {
    id:'1',
    name:'单行输入',
    prompt:'请输入'
  },
  {
    id:'2',
    name:'多行输入',
    prompt:'请输入'
  },
  {
    id:'3',
    name:'数字输入',
    prompt:'请输入数字'
  },
  {
    id:'4',
    name:'单项选择',
    prompt:'请选择',
  },
  {
    id:'5',
    name:'多项选择',
    prompt:'请选择',
  },
  {
    id:'6',
    name:'日期',
    prompt:'请选择',
    dateType:'1'
  },
  {
    id:'7',
    name:'日期区间',
    title:'开始时间',
    title_spare:'结束时间',
    prompt:'请选择',
    prompt_spare:'请选择',
    dateType:'1'
  },
  {
    id:'8',
    name:'图片'
  },
  {
    id:'9',
    name:'文件'
  },
  {
    id:'10',
    name:'说明',
    content:'说明内容'
  },
]
//信息库
let infoModule = [
  {
    id:'11',
    name:'申请人岗位'
  },
  {
    id:'12',
    name:'申请人部门'
  },
  {
    id:'13',
    name:'申请人工号'
  },
  {
    id:'14',
    name:'申请人入职日期'
  },
  {
    id:'15',
    name:'岗位选择',
    prompt:'请选择'
  },
  {
    id:'16',
    name:'部门选择',
    prompt:'请选择'
  },

  // {
  //   id:'17',
  //   name:'试用期',
  // },
  // {
  //   id:'18',
  //   name:'计划转正日',
  // },
  {
    id:'19',
    name:'员工选择',
    prompt:'请选择'
  },
  {
    id:'20',
    name:'申请人',
    prompt:'请选择'
  },

]
//审批状态
let approveStutes = [
  {
    id:'',
    name:'全部'
  },
  {
    id:'0',
    name:'审批中'
  },
  {
    id:'1',
    name:'审批通过'
  },
  {
    id:'2',
    name:'审批拒绝'
  },
  {
    id:'3',
    name:'审批撤销'
  },
]
//审批状态2
let approveStutes2 = [
  {
    id:'99',
    name:'全部'
  },
  {
    id:'1',
    name:'审批通过'
  },
  {
    id:'2',
    name:'审批拒绝'
  }
]

let toolbarTips = [
  {Choice:'.ql-bold',title:'加粗'},
  {Choice:'.ql-italic',title:'倾斜'},
  {Choice:'.ql-underline',title:'下划线'},
  {Choice:'.ql-header',title:'段落格式'},
  {Choice:'.ql-strike',title:'删除线'},
  {Choice:'.ql-blockquote',title:'块引用'},
  {Choice:'.ql-code-block',title:'插入代码段'},
  {Choice:'.ql-size',title:'字体大小'},
  {Choice:'.ql-list[value="ordered"]',title:'编号列表'},
  {Choice:'.ql-list[value="bullet"]',title:'项目列表'},
  {Choice:'.ql-header[value="1"]',title:'h1'},
  {Choice:'.ql-header[value="2"]',title:'h2'},
  {Choice:'.ql-align',title:'对齐方式'},
  {Choice:'.ql-color',title:'字体颜色'},
  {Choice:'.ql-background',title:'背景颜色'},
  {Choice:'.ql-image',title:'图像'},
  {Choice:'.ql-video',title:'视频'},
  {Choice:'.ql-link',title:'添加链接'},
  {Choice:'.ql-formula',title:'插入公式'},
  {Choice:'.ql-clean',title:'清除格式'},
  {Choice:'.ql-indent[value="-1"]',title:'向左缩进'},
  {Choice:'.ql-indent[value="+1"]',title:'向右缩进'},
  {Choice:'.ql-header .ql-picker-label',title:'标题大小'},
  {Choice:'.ql-header .ql-picker-item[data-value="1"]',title:'标题一'},
  {Choice:'.ql-header .ql-picker-item[data-value="2"]',title:'标题二'},
  {Choice:'.ql-header .ql-picker-item[data-value="3"]',title:'标题三'},
  {Choice:'.ql-header .ql-picker-item[data-value="4"]',title:'标题四'},
  {Choice:'.ql-header .ql-picker-item[data-value="5"]',title:'标题五'},
  {Choice:'.ql-header .ql-picker-item[data-value="6"]',title:'标题六'},
  {Choice:'.ql-header .ql-picker-item:last-child',title:'标准'},
  {Choice:'.ql-size .ql-picker-item[data-value="small"]',title:'小号'},
  {Choice:'.ql-size .ql-picker-item[data-value="large"]',title:'大号'},
  {Choice:'.ql-size .ql-picker-item[data-value="huge"]',title:'超大号'},
  {Choice:'.ql-size .ql-picker-item:nth-child(2)',title:'标准'},
  {Choice:'.ql-align .ql-picker-item:first-child',title:'居左对齐'},
  {Choice:'.ql-align .ql-picker-item[data-value="center"]',title:'居中对齐'},
  {Choice:'.ql-align .ql-picker-item[data-value="right"]',title:'居右对齐'},
  {Choice:'.ql-align .ql-picker-item[data-value="justify"]',title:'两端对齐'}
];

export let utils={
    getSign:getSign,
    getRandSix:getRandSix,
    isPoneAvailable:isPoneAvailable,
    isInteger:isInteger,
    noticeType:noticeType,
    sliderType:sliderType,
    sliderLocation:sliderLocation,
    qiniuUrl:qiniuUrl,
    qiniuAddr:qiniuAddr,
    workYear:workYear,
    educationList:educationList,
    sexList:sexList,
    channelList:channelList,
    educationOwn:educationOwn,
    isEmptyInteger:isEmptyInteger,
    validateEMail:validateEMail,
    validateFloatInt:validateFloatInt,
    userState:userState,
    voucherTypeList:voucherTypeList,
    workState:workState,
    validateIdNo:validateIdNo,
    timeDifference:timeDifference,
    userStatus:userStatus,
    removeType:removeType,
    removeStatus:removeStatus,
    leaveStatus:leaveStatus,
    checkingInType:checkingInType,
    checkingInType2:checkingInType2,
    holidayUnit:holidayUnit,
    classestype:classestype,
    clockInType:clockInType,
    taskStatus:taskStatus,
    outType:outType,
    overtimeType:overtimeType,
    repeatType:repeatType,
    taskType:taskType,
    perfType:perfType,
    cycle:cycle,
    assessState:assessState,
    PayType:PayType,
    ChineseNum:ChineseNum,
    baseModule:baseModule,
    infoModule:infoModule,
    approveStutes:approveStutes,
    holidayMin:holidayMin,
    approveStutes2:approveStutes2,
    toolbarTips:toolbarTips,

    // getRootMenu:getRootMenu
  }



// WEBPACK FOOTER //
// ./src/assets/js/utils.js